'use client'

import React from 'react'
import RichText from '@/components/RichText'
import { QuoteBlock } from '@/payload-types'

export function QuoteClient({ content }: QuoteBlock) {
  return (
    <div className="border-l-4 border-olive-2/10 my-[30px] pl-[20px] p-[15px]">
      <RichText
        data={content}
        className="opacity-80 [&_p]:md:!text-[24px] [&_p_*]:md:!text-[24px]"
      />
    </div>
  )
}
